module.exports = __webpack_public_path__ + "img/calendario.442970c8.png";